const router = [
  {
    path: '/index',
    name: 'index',
    component: () => import('./Index'),
  },
]

export default router
